import { NotificationService } from './shared/services/notification.service';
import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';


import { Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { LoaderComponent, ToasterComponent, DialogComponent, AlertboxComponent } from "@ppl/ui";
import { HeaderComponent } from './components/core/layout/header/header.component';
import { FooterComponent } from './components/core/layout/footer/footer.component';
import { AlertDetails, ErrorAlertService } from './shared/services/error-alert.service';

@Component({
  selector: 'ppl-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    AlertboxComponent,
    ToasterComponent,
    DialogComponent
],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'PPL CareConnect';
  isIframe = false;
  isAuthenticated = false;
  showLoader = false;
  private readonly _destroying$ = new Subject<void>();
  isAlertVisible  = false;
  alertDetails: AlertDetails = {type: 'error', title: '', message: '', isVisible: false};
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
    private errorAlertService: ErrorAlertService,
  ) { }

  ngOnInit(): void {
    this.showLoader = false;
    this.notificationService.loaderSubject$.pipe(
      tap((value) => {
        this.showLoader = value;
        this.cdr.detectChanges(); // trigger change detection and update the view.
      })
    ).subscribe();

    this.errorAlertService.getAlertDetails().subscribe((details) => {
      this.alertDetails = details;
      console.log('Alert Details', details);
    });

  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  @HostListener('window:beforeunload', ['$event'])
  clearLocalStorage(_event: BeforeUnloadEvent): void {
    localStorage.clear();
    localStorage.setItem('clearing_local_storage_date_time', new Date().toLocaleString());
  }
}
